module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-column",
    attrs: {
      "id": "ksm-app",
      "lang": "de"
    }
  }, [_c('header-view', {
    staticClass: "ksm-flex-00auto"
  }), _vm._v(" "), _c('keep-alive', {
    attrs: {
      "include": [
        'orteundwege',
        'modusstart',
        'medienOverview',
        'personen',
        'suche' ]
    }
  }, [_c('router-view', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "margin-bottom": "10px"
    }
  })], 1), _vm._v(" "), _c('footer-view', {
    staticClass: "ksm-flex-00auto"
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "ieModal"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-column",
    staticStyle: {
      "padding": "10px",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "text-align": "center",
      "margin": "10px",
      "font-size": "18pt"
    }
  }, [_vm._v("\n        Ihr Browser wird nicht unterstützt\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        Diese Webseite verwendet moderne Webtechnologien die von aktuellen\n        Browsern unterstützt werden. Mit Internet Explorer kann es zu\n        Verzeichnungen und Überlagerungen kommen.\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        Bitte verwenden Sie anstatt dessen einen der folgenden Browser:\n      ")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.google.com/intl/de/chrome/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Google Chrome")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.mozilla.org/de-de/firefox/new/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Firefox")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.apple.com/safari/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Safari")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.microsoft.com/windows/microsoft-edge",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Microsoft Edge")])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px 20px",
      "background-color": "grey",
      "color": "#fff",
      "display": "inline-block",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ieModal')
      }
    }
  }, [_vm._v("\n          Schließen\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c68a06","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1958
// module chunks = 1